import { render, staticRenderFns } from "./Main_menuPhone_JiaGeYuKuCun.vue?vue&type=template&id=34ec8530&scoped=true"
import script from "./Main_menuPhone_JiaGeYuKuCun.vue?vue&type=script&lang=js"
export * from "./Main_menuPhone_JiaGeYuKuCun.vue?vue&type=script&lang=js"
import style1 from "./Main_menuPhone_JiaGeYuKuCun.vue?vue&type=style&index=1&id=34ec8530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ec8530",
  null
  
)

export default component.exports